export enum InstanceStatus {
  Active = 'active',
  Inactive = 'inactive',
}
